import React, {useContext, useEffect, useReducer} from 'react';
import { object } from 'prop-types';
import {useQuery} from "react-query";
import {fetchShopsByBrand} from "../api/shop";
import {getGeolocation} from "../common/geoloc";

const SET_SHOPS_QUERY_PARAMS = 'SET_SHOPS_QUERY_PARAMS';

const aquaSheetContext = React.createContext();

const reducerFactory = () => {
    return (state, action) => {
        switch (action.type) {
            case SET_SHOPS_QUERY_PARAMS:
                return {
                    ...state,
                    shopsQueryParams: {
                        ...action.payload,
                        brand: state.shopsQueryParams.brand
                    },
                    ready: true,
                }
            default:
                return state
        }
    }
};

const AquaSheetContextProvider = (props) => {

    const initialState = props.initialState || {
        shops: [],
        gtmClassName: props.gtmClassName,
        shopsQueryParams: {
            latitude: null,
            longitude: null,
            brand: props.brand,
        },
        shopsQueryState: null,
        ready: false,
    };

    const [state, dispatch] = useReducer(reducerFactory(), initialState);


    let fetchShopQueryResult = useQuery(["shops", state.shopsQueryParams], fetchShopsByBrand, {
        enabled: state.ready && !state.shopsQueryState});

    const contextValue = [
        {...state, shopsQueryState: fetchShopQueryResult},
        {
            dispatch,
        },
    ];

    useEffect(()=>{
            getGeolocation().then((payload)=>{

                console.log('payload', payload);

                dispatch({type: SET_SHOPS_QUERY_PARAMS, payload: {
                        lat: payload.coords.latitude,
                        long: payload.coords.longitude,
                    }});
            })
    }, [])

    return <aquaSheetContext.Provider value={contextValue}>{props.children}</aquaSheetContext.Provider>;
}

AquaSheetContextProvider.propTypes = {
    initialState: object,
};

export default AquaSheetContextProvider;
export const useAquaSheetContext = () => useContext(aquaSheetContext);

